import {
  SurveyComponent,
  Survey as TreeSurvey,
} from "@tree-company/tree-query";
import { useMemo } from "react";
import { surveySettings } from "../surveys";
import I18n from "../locales";

function resolveVariant(searchParams) {
  const v = searchParams.get("v");
  if (v === "a" || v === "r") return v;
  return Math.random() < 0.5 ? "a" : "r";
}

export function Survey({ apiClient }) {
  const i18n = new I18n();
  const searchParams = new URLSearchParams(window.location.search);

  const variant = useMemo(() => resolveVariant(searchParams), []);

  const treesponse = useMemo(() => {
    return apiClient.initTreesponse({
      language: i18n.locale,
      surveyVersion: "v1",
    });
  }, []);

  const survey = useMemo(() => {
    return new TreeSurvey(surveySettings(variant), treesponse);
  }, []);

  return <SurveyComponent survey={survey} />;
}
